"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_delayed_initialization_1 = require("owa-delayed-initialization");
var loadRegionalOptions_1 = require("./orchestration/loadRegionalOptions");
// Load initial state needed for options
owa_delayed_initialization_1.runAfterBootstrap(function () {
    loadRegionalOptions_1.default();
});
// Export option itself
var RegionalOption_1 = require("./RegionalOption");
exports.RegionalOption = RegionalOption_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/index.js
// module id = 4918
// module chunks = 2